:host {
  display: block;
  box-sizing: border-box;
  user-select: none;
}

.EcoSuiteNavbarMenuItem,
.EcoSuiteNavbarMenuItem *,
.EcoSuiteNavbarMenuItem *::before,
.EcoSuiteNavbarMenuItem *::after {
  box-sizing: border-box;
}

.EcoSuiteNavbarMenuItem {
  display: flex;
  align-items: center;
  gap: var(--pdt-space-100);
  font-size: var(--pdt-text-body-sm-font-size);
  line-height: var(--pdt-line-height-sm);
  color: var(--pdt-color-text);
  font-family: inherit;
  font-weight: var(--pdt-text-body-sm-font-weight);
  padding: var(--pdt-space-100);
  appearance: none;
  width: 100%;
  outline: 0;
  border: 0;
  cursor: pointer;
  position: relative;
  text-decoration: none;
  border-radius: var(--pdt-radius-100);
  background-color: var(--pdt-color-surface);
  transition: background-color .2s ease, border-color .2s ease, box-shadow .2s ease, color .2s ease;

  &:hover {
    background-color: var(--pdt-color-bg-alpha-subtle-hovered);
  }

  &:active {
    background-color: var(--pdt-color-bg-alpha-subtle-pressed);
  }

  &:focus-visible {
    outline: 1px solid var(--pdt-color-border-focused);
    outline-offset: -1px;
    box-shadow: var(--pdt-shadow-focus);

    /* Ensure the focus shadow doesn't get cut off */
    z-index: 1;
  }

  &--current {
    background-color: var(--pdt-color-bg-selected);
    color: var(--pdt-color-text-selected);
    font-weight: var(--pdt-font-weight-medium);

    &:hover {
      background-color: var(--pdt-color-bg-selected-hovered);
    }

    &:active {
      background-color: var(--pdt-color-bg-selected-pressed);
    }
  }

  &__label,
  &__suffix {
    flex-grow: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: start;
  }

  &__suffix {
    flex-shrink: 0;
    color: var(--pdt-color-icon-alpha);
  }

  pwc-icon-shadow[icon="external-link"] {
    color: var(--pdt-color-text-medium);
  }
}
